import React from 'react';
import styled from 'styled-components';
import { Fade, Zoom } from "react-awesome-reveal";
import certification from '../Images/certification.jpg'

// --- Styled Components ---

const IsoSection = styled.section`
  padding: 10px 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  background-color: #ffffff;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
`;

const SmallHeader = styled.p`
  font-size: 1.1rem;
  font-weight: 600;
  color: #333;
  text-transform: uppercase;
  letter-spacing: 1.5px;
  // margin-bottom: 3px;
`;

const MainTitle = styled.h2`
  font-size: 2.5rem;
  font-weight: 800;
  color: #439E6D;
  text-transform: uppercase;
  margin: 0 0 5px 0;
  
  @media (max-width: 768px) {
    font-size: 1.8rem;
  }
`;

const ImageWrapper = styled.div`
  max-width: 450px;
  width: 100%;
  // margin-bottom: px;

  img {
    width: 100%;
    height: auto;
    display: block;
    /* Optional: Subtle shadow to make the badge pop */
    filter: drop-shadow(0px 10px 15px rgba(0,0,0,0.1));
  }
`;

const SectorTitle = styled.h3`
  font-size: 1.2rem;
  font-weight: 700;
  color: #1a2b49; // Dark navy color from the image
  text-transform: uppercase;
  margin-bottom: 8px;
`;

const SubText = styled.p`
  font-size: 0.75rem;
  color: #666;
  font-style: italic;
  margin: 0;
`;

// --- Component ---

const IsoCertification = () => {
  return (
    <IsoSection>
      {/* Top Titles */}
      <Fade direction="down" triggerOnce>
        <SmallHeader>PADEC GLOBAL SERVICES ISO CERTIFICATION</SmallHeader>
        <MainTitle>ISO Certification</MainTitle>
      </Fade>

      {/* Center Image with a Zoom effect */}
      <Zoom triggerOnce duration={1000}>
        <ImageWrapper>
          <img 
            src={certification} 
            alt="ISO 45001:2018 Certification Badge" 
          />
        </ImageWrapper>
      </Zoom>

      {/* Footer Text */}
      {/* <Fade direction="up" triggerOnce delay={300}>
        <SectorTitle>Our Client Sector</SectorTitle>
        <SubText>We care and respect our clients.</SubText>
      </Fade> */}
    </IsoSection>
  );
};

export default IsoCertification;